<script setup lang="ts">
import { useLocalization } from '@/plugins/localization'
import { routePaths } from '@/router/router-constants'

const { t } = useLocalization()
</script>

<template>
  <div class="flex h-screen items-center justify-center text-center">
    <div class="flex h-full max-w-xl flex-col items-center justify-center gap-4">
      <h1 class="text-5xl md:text-8xl">{{ t('notFound.code', { code: '404' }) }}</h1>
      <p class="text-2xl text-surface-600 md:text-3xl">{{ t('notFound.message') }}</p>
      <router-link :to="routePaths.home">
        <Button>
          {{ t('notFound.button') }}
        </Button>
      </router-link>
    </div>
  </div>
</template>
